module.exports = __webpack_public_path__ + "img/border_regular_hexagon.43c19173.svg";